import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';

const RemoveButton = props => {
  const { onRemoveHandler } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    handleClose();
    onRemoveHandler();
  };

  return (
    <div>
      <Button autoFocus color="primary" onClick={handleClickOpen} size="small">
        Remove
      </Button>
      <Dialog
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        onClose={handleClose}
        open={open}>
        <DialogTitle id="alert-dialog-title">Are you sure you want to remove this upload ?</DialogTitle>
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button autoFocus color="secondary" onClick={handleDelete} variant="contained">
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

RemoveButton.propTypes = {
  onRemoveHandler: PropTypes.func,
};

RemoveButton.defaultProps = {
  onRemoveHandler: () => null,
};

export default RemoveButton;
